import React from 'react';
import useIsMobile from '@dapp/multi-lib/ui/shared-hooks/useIsMobile';
import { EcoSystemCardDesktop } from './EcoSystemCardDesktop';
import { EcoSystemCardMobile } from './EcoSystemCardMobile';

interface CardData {
  title: string;
  description: string;
  Link: string;
  logo: string;
  backDetails: string;
}
interface EcoSystemCardDesktopProps {
  cardData: CardData[];
  title: string;
}
export const EcoSystemCard: React.FC<EcoSystemCardDesktopProps> = ({
  cardData,
  title,
}) => {
  const isMobile = useIsMobile();
  return (
    <>
      {isMobile ? (
        <EcoSystemCardMobile cardData={cardData} title={title} />
      ) : (
        <EcoSystemCardDesktop cardData={cardData} />
      )}
    </>
  );
};
